function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { WDHComponent, onEvent } from '../../../../../wdh-foundation/wdh';
import { blockClickEvents, toggleActiveClassOnClick } from './header-utils';
import OticonHeaderShoppingCartLink from './header-shopping-cart-link';
import { accesibility } from "./accessibility";
var $ = jQuery; // eslint-disable-line no-undef
var IS_CURRENT = 'is-current';
var IS_ACTIVE = 'is-active';
var FAVORITE_FEATURE_NAME = 'favoriteProducts';
window.headerFavoriteFeatureImporter = function () {
  if (!window.favoriteFeatureImported) {
    import(/* webpackChunkName: "favorite-feature", webpackPrefetch: true */'./favorite-products-feature').then(function () {
      window.favoriteFeatureImported = true;
      console.log('favorite-products-feature loaded');
    }).catch(function (error) {
      console.log('An error occurred while loading the favorite-products-feature');
      console.log(error);
    });
  }
};
export var FAVORITE_ICON = 'favorite-icon-target';
var OticonHeaderStickyNavigation = /*#__PURE__*/function (_WDHComponent) {
  function OticonHeaderStickyNavigation(className) {
    var _this;
    _classCallCheck(this, OticonHeaderStickyNavigation);
    _this = _callSuper(this, OticonHeaderStickyNavigation, [className]);
    _this.isMobileState = false;
    _this.onStickyStateChanged = null;
    _this.positionControllingElement = null;
    return _this;
  }
  _inherits(OticonHeaderStickyNavigation, _WDHComponent);
  return _createClass(OticonHeaderStickyNavigation, [{
    key: "navigationElement",
    set: function set(value) {
      this.navigation = value;
    }
  }, {
    key: "init",
    value: function init(component) {
      if (!this.navigation) {
        return;
      }
      this.removeInitialActiveStateFromNavigation(this.navigation);
      this.stickyContainer = this.createStickyContainer('sticky-navigation');
      this.addElementContainerToComponent(this.stickyContainer, component);
      var stickyInnerContainer = this.createStickyContainer('sticky-navigation-inner');
      this.addElementContainerToComponent(stickyInnerContainer, this.stickyContainer);
      var initialPosition = this.calculatePosition();
      if (initialPosition) {
        this.setStickyPosition(initialPosition);
      }
      this.addSecondLevelNavigationToContainer(stickyInnerContainer);
      var stickyActionsContainer = this.addActionsMenu(stickyInnerContainer);
      toggleActiveClassOnClick(this.stickyContainer, '.level2 > a', IS_ACTIVE);
      blockClickEvents(this.stickyContainer, '.level2.has-children > a, .level3.has-children > a');
      this.shoppingClassLink = new OticonHeaderShoppingCartLink('.sticky-navigation .shopping-cart-link', stickyActionsContainer, document.querySelector('.header .two-section-grid .section-one'));
      this.shoppingClassLink.run(this.isMobileState);
      this.wrapThirdLevelInInnerContainer(this.stickyContainer);
      this.addCloseButtonToThirdLevelInnerContainer('close-button', this.stickyContainer);
      this.addClickEventToCloseButton('.close-button', component);
      this.addClickOutsideToClose(component);
      this.setupB2BEventListener(component);
      this.menuLinesException();
      this.addFavoriteProductsFeature();
      accesibility.init('#header');
    }
  }, {
    key: "removeInitialActiveStateFromNavigation",
    value: function removeInitialActiveStateFromNavigation(navigation) {
      var activeItems = this.getNodesFromSelector("li.".concat(IS_ACTIVE), navigation);
      activeItems.forEach(function (activeItem) {
        activeItem.classList.remove(IS_ACTIVE);
      });
    }
  }, {
    key: "createStickyContainer",
    value: function createStickyContainer(cssClass) {
      var container = document.createElement('div');
      container.classList.add(cssClass);
      return container;
    }
  }, {
    key: "addElementContainerToComponent",
    value: function addElementContainerToComponent(element, container) {
      container.appendChild(element);
    }
  }, {
    key: "getInitialTopPosition",
    value: function getInitialTopPosition(container) {
      return container.offsetTop - 1;
    }
  }, {
    key: "calculatePosition",
    value: function calculatePosition() {
      if (this.positionControllingElement) {
        return this.positionControllingElement.getBoundingClientRect().height - 1;
      }
      return null;
    }
  }, {
    key: "setStickyPosition",
    value: function setStickyPosition(position) {
      this.stickyContainer.classList.add('is-sticky');
      this.stickyContainer.style.top = "".concat(Math.round(position), "px");
    }
  }, {
    key: "addSecondLevelNavigationToContainer",
    value: function addSecondLevelNavigationToContainer(container) {
      container.appendChild(this.navigation);
    }
  }, {
    key: "addActionsMenu",
    value: function addActionsMenu(container) {
      var stickyInnerActionsContainer = this.createStickyContainer('sticky-navigation-actions');
      this.addElementContainerToComponent(stickyInnerActionsContainer, container);
      return stickyInnerActionsContainer;
    }
  }, {
    key: "wrapThirdLevelInInnerContainer",
    value: function wrapThirdLevelInInnerContainer(container) {
      $('.level2 > ul', container).each(function () {
        $('.level3', this).wrapAll('<div class="inner-level3"></div>');
      });
    }
  }, {
    key: "addCloseButtonToThirdLevelInnerContainer",
    value: function addCloseButtonToThirdLevelInnerContainer(cssClass, container) {
      var _this2 = this;
      var innerContainers = this.getNodesFromSelector('.inner-level3', container);
      innerContainers.forEach(function (innerContainer) {
        var closeButton = _this2.createCloseButton(cssClass);
        _this2.addElementContainerToComponent(closeButton, innerContainer);
      });
    }
  }, {
    key: "addClickEventToCloseButton",
    value: function addClickEventToCloseButton(cssClass, component) {
      var _this3 = this;
      var closeButtons = this.getNodesFromSelector(cssClass);
      closeButtons.forEach(function (closeButton) {
        _this3.addMultipleEvents(['click', 'keypress'], closeButton, component);
      });
    }
  }, {
    key: "addMultipleEvents",
    value: function addMultipleEvents(eventsArr, closeButton, component) {
      var _this4 = this;
      eventsArr.forEach(function (event) {
        closeButton.addEventListener(event, function () {
          _this4.removeLevel2ActiveClass(component);
        });
      });
    }
  }, {
    key: "addFavoriteProductsFeature",
    value: function addFavoriteProductsFeature() {
      var favoriteContainer = document.createElement('div');
      favoriteContainer.classList.add(FAVORITE_ICON);
      document.querySelector('#header .sticky-navigation-inner').appendChild(favoriteContainer);
      if (window.sessionStorage.getItem(FAVORITE_FEATURE_NAME)) {
        window.headerFavoriteFeatureImporter();
      }
    }
  }, {
    key: "addClickOutsideToClose",
    value: function addClickOutsideToClose(component) {
      var _this5 = this;
      document.body.addEventListener('click', function (event) {
        if (!document.querySelector('#header').contains(event.target)) {
          _this5.removeLevel2ActiveClass(component);
        }
      });
    }
  }, {
    key: "setupB2BEventListener",
    value: function setupB2BEventListener(component) {
      var _this6 = this;
      onEvent('ADD_MENUITEMS', function (payload) {
        return _this6.onB2BMenuItemAdd(payload, component);
      });
    }
  }, {
    key: "onB2BMenuItemAdd",
    value: function onB2BMenuItemAdd(payload, component) {
      var _this7 = this;
      this.clearThirdLevel();
      var thirdLevelRoot = this.getThirdLevelRoot();
      var payloadRoot = payload.menuItems;
      var numChildren = 0;
      if (payloadRoot.constructor === Array) {
        var index = 0;
        payloadRoot.forEach(function (menuItem) {
          numChildren += 1;
          var html = _this7.createThirdLevelMenuItem(menuItem, index, '3');
          $(thirdLevelRoot).append(html);
          index += 1;
        });
      }
      this.adjustSecondLevelNumChildrenClassName(numChildren);
      if (thirdLevelRoot) {
        this.addCloseButtonToThirdLevelInnerContainer('close-button', thirdLevelRoot.parentNode);
      }
      this.addClickEventToCloseButton('.close-button', component);
      blockClickEvents(this.stickyContainer, '.level2.has-children > a, .level3.has-children > a');
    }
  }, {
    key: "clearThirdLevel",
    value: function clearThirdLevel() {
      var thirdLevelUl = this.getThirdLevelRoot();
      while (thirdLevelUl && thirdLevelUl.firstChild) {
        thirdLevelUl.removeChild(thirdLevelUl.firstChild);
      }
    }
  }, {
    key: "getThirdLevelRoot",
    value: function getThirdLevelRoot() {
      var selector = "li.level2.".concat(IS_CURRENT, " ul .inner-level3");
      return this.stickyContainer.querySelector(selector);
    }
  }, {
    key: "createThirdLevelMenuItem",
    value: function createThirdLevelMenuItem(config, index, level) {
      var _this8 = this;
      var oddEvenClass = index % 2 ? 'odd' : 'even';
      var itemHasChildren = config.hasOwnProperty('menuItems') && config.menuItems.length > 0;
      var childrenClass = itemHasChildren ? " has-children num-children-".concat(config.menuItems.length) : '';
      var html = "<li class=\"level".concat(level, " item").concat(index, " ").concat(oddEvenClass).concat(childrenClass, "\"><a title=\"").concat(config.title, "\" href=\"").concat(config.url, "\">").concat(config.title, "</a>");
      if (itemHasChildren) {
        html += '<ul>';
        var subIndex = 0;
        config.menuItems.forEach(function (menuItem) {
          html += _this8.createThirdLevelMenuItem(menuItem, subIndex, '4');
          subIndex += 1;
        });
        html += '</ul>';
      }
      html += '</li>';
      return html;
    }
  }, {
    key: "adjustSecondLevelNumChildrenClassName",
    value: function adjustSecondLevelNumChildrenClassName(numChildren) {
      var currentSecondLevel = this.getCurrentSecondLevel();
      if (currentSecondLevel === null) {
        return;
      }
      var currentNumChildrenClassName = '';
      currentSecondLevel.classList.forEach(function (className) {
        if (className.substr(0, 12) === 'num-children') {
          currentNumChildrenClassName = className;
        }
      });
      if (currentNumChildrenClassName !== '') {
        currentSecondLevel.classList.remove(currentNumChildrenClassName);
      }
      currentSecondLevel.classList.add("num-children-".concat(numChildren));
    }
  }, {
    key: "getCurrentSecondLevel",
    value: function getCurrentSecondLevel() {
      var selector = "li.level2.".concat(IS_CURRENT);
      return this.stickyContainer.querySelector(selector);
    }
  }, {
    key: "removeLevel2ActiveClass",
    value: function removeLevel2ActiveClass(component) {
      var activeLevel2Items = this.getNodesFromSelector(".level2.".concat(IS_ACTIVE), component);
      activeLevel2Items.forEach(function (level2Item) {
        level2Item.classList.remove(IS_ACTIVE);
      });
    }
  }, {
    key: "menuLinesException",
    value: function menuLinesException() {
      if (document.getElementsByClassName('sticky-navigation-inner')[0].offsetHeight > 42) {
        document.getElementsByClassName('sticky-navigation')[0].classList.add('menu-two-lines');
      } else {
        document.getElementsByClassName('sticky-navigation')[0].classList.remove('menu-two-lines');
      }
    }
  }, {
    key: "createCloseButton",
    value: function createCloseButton(cssClass) {
      var container = document.createElement('div');
      container.classList.add(cssClass);
      container.appendChild(document.createElement('span'));
      container.appendChild(document.createElement('span'));
      return container;
    }
  }, {
    key: "resize",
    value: function resize(component) {
      if (!this.navigation) return;
      if (this.isMobileState) {
        component.style.marginBottom = 'auto';
      } else {
        var stickyNavigationHeight = this.stickyContainer.getBoundingClientRect().height;
        component.style.marginBottom = "".concat(Math.round(stickyNavigationHeight), "px");
        this.menuLinesException();
      }
      this.shoppingClassLink.moveToContainer(this.isMobileState);
    }
  }, {
    key: "scroll",
    value: function scroll(component, scrollTop) {
      if (!this.navigation) return;
      var initialPosition = this.calculatePosition();
      if (initialPosition) {
        var position = Math.max(initialPosition - window.pageYOffset, -1);
        this.setStickyPosition(position);
      }
    }
  }, {
    key: "isMobile",
    set: function set(value) {
      this.isMobileState = value;
    }
  }]);
}(WDHComponent);
export default OticonHeaderStickyNavigation;